var _path, _path2, _path3, _path4, _circle, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCashPayment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Filled",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m409.1 468.69-33.1 10.36-28.6 8.95h-150.21l-29.19-93.26-96-306.74 96-30.05 102.5-32.08 105.5 337.07z",
    fill: "#379a6b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m338.929 431.973 7.168 22.904-91.617 28.675-7.169-22.905-22.904 7.169-105.141-335.931 22.904-7.168-7.168-22.905 91.617-28.674 7.169 22.904 22.904-7.169 105.141 335.931z",
    fill: "#44c086"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m168 24h208v464h-208z",
    fill: "#3ba673"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m320 432v24h-96v-24h-24v-352h24v-24h96v24h24v352z",
    fill: "#44c086"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 272,
    cy: 256,
    fill: "#3ba673",
    r: 40
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m440 296v192h-56a80 80 0 0 1 -80-80h.16l-51.9-76.805a32 32 0 0 1 8.6-44.43 32 32 0 0 1 44.43 8.6l46.71 64.635h24v-192l60.235 112.941a32 32 0 0 1 3.765 15.059z",
    fill: "#f5cbaa"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m160 395.963v92.037a8 8 0 0 0 8 8h272a8 8 0 0 0 8-8v-192a40.132 40.132 0 0 0 -4.706-18.823l-59.294-111.177v-142a8 8 0 0 0 -8-8h-208a8 8 0 0 0 -8 8v28.072l-90.39 28.293a8 8 0 0 0 -5.245 10.025zm-10.195-273.632-4.781-15.276 14.976-4.688v132.878l-30.706-98.11 15.267-4.78a8 8 0 0 0 5.244-10.024zm282.195 173.669v184h-48a72.085 72.085 0 0 1 -71.984-70.485 8 8 0 0 0 -1.227-5.994l-51.889-76.805a24 24 0 1 1 39.771-26.872c.047.069.1.138.145.206l46.705 64.636a8 8 0 0 0 6.479 3.314h24a8 8 0 0 0 8-8v-160l45.177 84.706a24.1 24.1 0 0 1 2.823 11.294zm-208 128h-16v-336h16a8 8 0 0 0 8-8v-16h80v16a8 8 0 0 0 8 8h16v236.2l-24.15-33.423a40.352 40.352 0 0 0 -3.078-3.948 47.99 47.99 0 1 0 -65.36 7.729 40.118 40.118 0 0 0 2.225 41.117l50.391 74.58a87.4 87.4 0 0 0 9.611 37.745h-73.639v-16a8 8 0 0 0 -8-8zm32.387-143.864c-.956.646-1.872 1.335-2.76 2.051a32 32 0 1 1 42.347-5 40.013 40.013 0 0 0 -39.587 2.949zm-80.387-248.136h192v320h-11.911l-4.089-5.659v-266.341a8 8 0 0 0 -8-8h-16v-16a8 8 0 0 0 -8-8h-96a8 8 0 0 0 -8 8v16h-16a8 8 0 0 0 -8 8v352a8 8 0 0 0 8 8h16v16a8 8 0 0 0 8 8h92.189a88.722 88.722 0 0 0 17.305 16h-157.494zm-16 36.837v16.763l-27.39 8.574a8 8 0 0 0 -5.245 10.024l4.781 15.277-15.267 4.779a8 8 0 0 0 -5.244 10.025l48.365 154.533v53.582l-77.976-249.149z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashPayment);
export default __webpack_public_path__ + "static/media/cash-payment.b83bf5277683f73680a9b9dd0cd3e2cc.svg";
export { ForwardRef as ReactComponent };